export default __webpack_public_path__ + "static/media/Sentiment.2ba2d690.png";